<script>
  import WelcomeNoteActiveIndicator from '@app-components/WelcomeNoteActiveIndicator.svelte';
  import GroupOptimizedIndicator from '@app-components/GroupOptimizedIndicator.svelte';
  import ListSettingsModal from '@app-components/modal/ListSettingsModal.svelte';
  import { goto } from '$app/navigation';
  import { getContext } from 'svelte';

  export let group;
  export let recs;
  export let topNavBar = false;
  let showListSettingsModal = false;
  let allGroupRecsLoadedStore = getContext('allGroupRecsLoadedStore');
</script>

<style style="text/scss" lang="scss" global>
  .group-settings {
    .group-emoji {
      width: 25px;
      height: 25px;
      margin-right: 11px;
    }
    .items-count {
      font-size: 16px;
      line-height: 24px;
      color: #1a1a1a;
      opacity: 0.5;
      margin-right: 16px;
    }
  }
  .group-settings.top-nav-bar {
    align-items: center;
    .group-emoji {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    .items-count {
      color: var(--neutral-gray, #7f7f7f);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }
  }
</style>

<ListSettingsModal
  group={group}
  on:url-changed={(e) => {
    goto(e.detail.group.url);
  }}
  bind:showModal={showListSettingsModal} />
<span class="group-settings" class:top-nav-bar={topNavBar}>
  <img
    class="group-emoji"
    src={group.emoji.outside_src ? group.emoji.outside_src : '/emojis/purple_star.png'}
    alt="{group.emoji.outside_src ? group.emoji.name : 'star'} emoji" />

  <span class="items-count" style={$allGroupRecsLoadedStore ? 'opacity: .5' : 'opacity: 0'}>
    {#if $allGroupRecsLoadedStore}
      {[...new Set(recs.map((x) => x.rec_object_id))].length}
    {:else}
      {group.items_count}
    {/if}
    items
  </span>
  <GroupOptimizedIndicator location="group" />
  <WelcomeNoteActiveIndicator location="group" />
  {#if group.permissions.edit}
    <span
      style="cursor: pointer;"
      on:click|preventDefault|stopPropagation={() => {
        showListSettingsModal = true;
      }}>
      <img src="/images/settings.png" />
    </span>
  {/if}
</span>
